<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn icon light @click="$router.go(-1)" slot="activator">
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title>{{ title }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark color="blue" @click="openNewMessageDialog()">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout row wrap mt-3 mb-3>
        <v-flex xs12 sm10 offset-sm1 text-xs-center>
          <v-progress-circular
            indeterminate
            color="grey lighten-2"
            :size="100"
            :width="10"
            v-if="messagesLoading"
          ></v-progress-circular>
          <v-card v-else>
            <v-list three-line v-if="messages.length > 0">
              <template v-for="(item, index) in messages">
                <v-list-tile
                  :key="index"
                  avatar
                  :to="{ name: 'webmailshow', params: { id: item.id } }"
                  v-bind:class="{ unread: !item.isRead }"
                >
                  <v-list-tile-avatar color="indigo">
                    <span class="white--text title">{{
                      item.from
                        ? item.from.emailAddress.name
                            .split(' ')
                            .map(i => i.charAt(0))
                            .join('')
                        : 'NA'
                    }}</span>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="item.from ? item.from.emailAddress.name : ''"
                      class="content"
                    >
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="item.subject"
                      class="content body-1"
                    ></v-list-tile-sub-title>
                    <v-list-tile-sub-title
                      v-html="item.bodyPreview"
                      class="content caption"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action class="action">
                    <v-list-tile-action-text>{{
                      formatDate(item.receivedDateTime)
                    }}</v-list-tile-action-text>
                    <v-icon
                      v-if="item.hasAttachments"
                      color="grey lighten-1"
                      small
                    >
                      attach_file
                    </v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
            <v-alert :value="true" color="info" icon="info" outline v-else>
              Your mailbox is empty
            </v-alert>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="white" flat>
          <v-btn icon @click="closeNewMessageDialog()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>New Message</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="sendMessage()">
              <v-icon color="blue">
                send
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-flex xs12>
          <v-autocomplete
            v-model="to"
            :items="contacts"
            :loading="isLoading"
            :search-input.sync="search"
            item-text="scoredEmailAddresses[0].address"
            item-value="scoredEmailAddresses[0].address"
            color="white"
            label="To"
            return-object
            chips
            clearable
            multiple
            deletable-chips
            small-chips
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <v-autocomplete
            v-model="cc"
            :items="contacts"
            :loading="isLoading"
            :search-input.sync="search"
            item-text="scoredEmailAddresses[0].address"
            item-value="scoredEmailAddresses[0].address"
            color="white"
            label="CC"
            return-object
            chips
            clearable
            multiple
            deletable-chips
            small-chips
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            prefix="Subject:"
            class="no-border pa-1"
            v-model="subject"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            name="message"
            label="Message"
            auto-grow
            v-model="message"
          ></v-textarea>
        </v-flex>
        <attachments></attachments>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import AttachmentsWrapper from '../components/AttachmentsWrapper'
export default {
  name: 'Inbox',
  mixins: [],
  components: {
    attachments: AttachmentsWrapper
  },
  data() {
    return {
      dialog: false,
      to: '',
      subject: '',
      cc: '',
      message: '',
      descriptionLimit: 60,
      people: [],
      isLoading: false,
      search: null,
      isSelecting: false,
      type: 'new',
      folder: 'Inbox',
      title: 'Inbox',
      messages: [],
      messagesLoading: true
    }
  },

  mounted() {
    this.title = this.$route.params.folder
      ? this.$route.params.folder
      : this.folder
  },
  computed: {
    ...mapState({
      // messages: state => state.webmail.messages,
      contacts: state => state.webmail.contacts,
      outbox: state => state.webmail.outbox
    }),
    ...mapGetters({
      user: 'root/user'
    })
  },
  created() {
    const that = this
    this.readMessages({
      latest: true,
      folder: this.$route.params.folder || null
    }).then(function(response) {
      that.messages = response
      that.messagesLoading = false
    })
  },
  methods: {
    ...mapActions({
      readMessages: 'webmail/readMessages',
      getContacts: 'webmail/getContacts',
      sendEmail: 'webmail/sendEmail',
      clearAttachments: 'webmail/clearAttachments'
    }),
    openNewMessageDialog() {
      this.dialog = true
    },
    closeNewMessageDialog() {
      this.dialog = false
      this.clearAttachments()
    },
    sendMessage() {
      const data = {
        to: this.to,
        cc: this.cc,
        subject: this.subject,
        message: this.message,
        user: this.user.imap_username,
        type: this.type,
        attachments: this.outbox ? this.outbox.attachments : [],
        parentId: this.outbox ? this.outbox.parent_id : null
      }
      this.sendEmail({ data: data })
      this.dialog = false
      this.outbox = []
    },
    formatDate(date) {
      return moment(date).format('ddd D/M')
    },
    fetchContactsDebounced(val) {
      clearTimeout(this._searchTimerId)
      this._searchTimerId = setTimeout(() => {
        this.getContacts({ q: val })
      }, 500) /* 500ms throttle */
    }
  },
  watch: {
    search(val) {
      this.fetchContactsDebounced(val)
    }
  }
}
</script>
<style scoped>
.content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.unread .content {
  font-weight: bold;
}
.unread .body-1 {
  color: #0066ff;
}
.action {
}
</style>
